import { setAgrEnvironment, AgrProcessEnv, AgrEnvironment } from '@next/core-lib/environment';

export class Environment extends AgrEnvironment {
  // add app specific environment variables here
  POWER_BI_LINK_ENABLED?: boolean;
  POWER_BI_URL?: string;

  constructor(env: Environment) {
    super(env);
  }
}

export const setEnvironment = ({
  /* APP_SPECIFIC_ENV, */
  POWER_BI_LINK_ENABLED,
  POWER_BI_URL,
  ...env
}: AgrProcessEnv): Environment =>
  new Environment({
    /* APP_SPECIFIC_ENV, */
    /* APP_SPECIFIC_ENV: ..., */
    POWER_BI_LINK_ENABLED: POWER_BI_LINK_ENABLED === 'true',
    POWER_BI_URL,
    ...setAgrEnvironment(env),
  });

export const environment = {} as Environment;
